/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentScheduleTypes } from './equipment-schedule-types';


export interface EquipmentScheduleNextPointDto { 
    at?: string;
    modeId?: number;
    scheduleId?: string;
    scheduleName?: string | null;
    scheduleType?: EquipmentScheduleTypes;
}



